import * as THREE from 'three'
import Experience from '@experience/Experience.js'
import Debug from '@experience/Utils/Debug.js'
import Properties from "@experience/Properties.js";
import Resources from "@experience/Utils/Resources.js";
import * as helpers from "@experience/Utils/HelpersFunctions.js";
import Model from "./Abstracts/Model.js";

export default class LymphaticSystem extends Model {
    experience = new Experience()
    debug = new Debug()
    properties = new Properties()
    scene = experience.scene
    time = experience.time
    camera = experience.camera.instance
    renderer = experience.renderer.instance
    resources = experience.resources
    cursor = experience.cursor
    timeline = experience.timeline;

    loadingModel = false;

    sources = [ {
        name: 'lymphaticSystemModel',
        type: 'gltfModel',
        path: 'models/lymphatic_system/lymphatic_system.gltf'
    } ]
    sourcesReady = 'LymphaticSystemReady'

    container = new THREE.Group();

    constructor( body ) {
        super()
        this.body = body

        // this.setModel()
        // this.setDebug()
    }

    setModel() {
        this.lymphaticSystemModel = this.resources.items.lymphaticSystemModel.scene

        helpers.meshToBatchedMesh( this.lymphaticSystemModel, this.container, this.body.batchedMeshesIds )

        //this.body.changeVisibility( this.lymphaticSystemModel, false )

        //this.container.add( this.lymphaticSystemModel );
        //helpers.cloneAllMaterials( this.container );
        this.body.container.add( this.container );
    }

    resize() {

    }

    setDebug() {
        if ( !this.debug.active ) return
    }

    update( deltaTime ) {

    }

}
